import * as React from 'react';

import { Switch } from './components/ui/switch.js';
import { cn } from './lib/utils.js';

const TONE_CLASSES = {
  default: undefined,
  success: 'data-checked:bg-green-600 dark:data-checked:bg-green-500',
} as const;

export type DimeSwitchProps = React.ComponentProps<typeof Switch> & {
  /** `success` turns the checked track green; `default` keeps the base switch colour. */
  tone?: keyof typeof TONE_CLASSES;
};

export function DimeSwitch({ className, tone = 'default', ...props }: Readonly<DimeSwitchProps>) {
  return <Switch className={cn(TONE_CLASSES[tone], className)} {...props} />;
}

DimeSwitch.displayName = 'DimeSwitch';
